export enum TableColumnTypeEnum {
    Text,
    TextOrNA,
    MultiValueOrNA,
    Number,
    Date,
    DateTime,
    SeverityLabel,
    StatusLabel,
    Toggle,
    CopyableText,
    Link,
    LinkNewPage,
    InternalNavigation,
    Icon,
    TextWithIcon,
    Modified,
    DropDownOptions,
    Actions,
    Label,
    Tag,
    TextWithIconAndTooltip,
    TextPopup,
}

export enum WidthType {
    Percentage,
    Pixel,
}

export interface ITableColumn {
    readonly labelPath: string;
    readonly propertyKey: string;
    readonly colType: TableColumnTypeEnum;
    readonly width: number;

    // This will be used to show the width type, dynamic or static
    // But also will be used on the main resource table to set if the column is resizable
    readonly widthType: WidthType;

    // User only when the type of the column is link
    readonly linkPropertyKey?: string;

    // Represent if the column value needs to be start with a capital letter and all other characters will be lower case
    readonly toCapitalize?: boolean;

    // Represent if a column is sortable.
    readonly isSortable?: boolean;
    // Represent the key used for the sort
    readonly sortKey?: string;

    // A path to the label which describes the column
    readonly descriptionLabelPath?: string;

    // Use only when the column is of type Internal Navigation
    readonly internalNavigationRoute?: string;
    readonly internalNavigationQuery?: string;

    // use when you need a specific style for the icon
    readonly iconTableClass?: string;

    // in case you want to add tooltip text for icon column
    readonly tooltipIconText?: string;

    readonly iconSrc?: string;

    // Use only when you want to add text on tooltip
    readonly tooltipDynamicText?: string;

    readonly textColor?: string;

    // Use only for copyable column to show or hide the copyable text
    readonly withCopyIcon?: boolean;
    readonly iconOnly?: boolean;

    // Use only when you want a border for your icon
    readonly iconBorder?: boolean;

    // Use only for copyable column the text
    readonly customCopyButtonTextLabel?: string;

    // Use only for popup column
    readonly textPopupTitleKey?: string;
    readonly textPopupTextKey?: string;

    // Will be used by the logic that handles the column shown
    // See usage example on ColumnsSelectionComponent
    readonly toggleState?: boolean;
    hidden?: boolean;
}
